/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Windows_S1Inputs */

const en_fc_dl_windows_s1 = /** @type {(inputs: Fc_Dl_Windows_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the MSI that matches your PC: x64 for most computers, ARM64 for Snapdragon laptops.`)
};

/**
* | output |
* | --- |
* | "Pick the MSI that matches your PC: x64 for most computers, ARM64 for Snapdragon laptops." |
*
* @param {Fc_Dl_Windows_S1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_windows_s1 = /** @type {((inputs?: Fc_Dl_Windows_S1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Windows_S1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_windows_s1(inputs)
});
export { fc_dl_windows_s1 as "fc.dl.windows.s1" }